import React, { useEffect, useState } from "react";
import "./TestimonialSection.css";
import landingimg9 from "../../../../images/landing9.png";
import { FaQuoteLeft, FaChevronLeft, FaChevronRight } from "react-icons/fa";
const testimonials = [
  {
    text: "With eBench, our hiring cycle reduced from 35 days to just 1 day. The platform helped us connect with top candidates across Bengaluru, Pune, and Hyderabad—without compromising on quality.",
    author: "Divya Singh",
    role: "Project Manager, Shilsha Technologies, India",
  },
  {
    text: "eBench transformed how we hire. The candidate quality and turnaround time exceeded our expectations.",
    author: "Abhishek Singh",
    role: "Tech Lead, eBench Technologies, India",
  },
  {
    text: "The platform is intuitive and powerful. Our recruitment efficiency increased significantly within weeks.",
    author: "Ananya Rao",
    role: "Talent Acquisition Manager, India",
  },
];

const TestimonialSection = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % testimonials.length);
    }, 10000); // auto-slide every 5s

    return () => clearInterval(timer);
  }, []);

  const prevSlide = () => {
    setIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % testimonials.length);
  };

  const { text, author, role } = testimonials[index];

  return (
    <section
      className="testimonial-section"
      style={{
        background: `
          linear-gradient(
            0deg, 
            rgba(0, 0, 0, 0.45) 0%, 
            rgba(0, 0, 0, 0.45) 100%
          ), 
          url(${landingimg9}) center/cover no-repeat
        `,
      }}
    >
      <div className="quote-icon">
        <FaQuoteLeft />
      </div>

      <h2 className="testimonial-heading">They speak about us…</h2>

      <p className={`testimonial-text testimonial-show`}>“{text}”</p>

      <p className={`testimonial-author testimonial-show`}>
        {author}, <span>{role}</span>
      </p>

      {/* Controls */}
      <div className="testimonial-controls">
        <button onClick={prevSlide}>
          <FaChevronLeft />
        </button>
        <button onClick={nextSlide}>
          <FaChevronRight />
        </button>
      </div>

      {/* <button className="testimonial-btn">Read more testimonials</button> */}
    </section>
  );
};

export default TestimonialSection;
